import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { t } from 'translation'

import SettingsPlaylistSongList from './SettingsPlaylistSongList'
import SettingsPlaylistSelectedList from './SettingsPlaylistSelectedList'

import { ReactComponent as PlayIcon } from '../../assets/icons/play.svg'

import { startPlaylist } from 'store/actions'
import history from 'utils/appHistory'

class SettingsPlaylist extends Component {
  state = {
    tab: 'songs',
    isBtnAddFixed: false,
  }

  container = React.createRef()

  controlButton = React.createRef()

  changeTabHandler = (target) => {
    this.setState({
      tab: target,
    })
  }

  setBtnControlFixed() {
    if (!this.container.current || !this.controlButton.current) return

    const containerHeight = this.container.current.offsetHeight
    const controlButtonHeight = this.controlButton.current.offsetHeight

    if (this.state.isBtnAddFixed) {
      // Need to add control button height when button is fixed and
      // removed from height of container to prevent infinite loop
      // when difference in height is close to button height
      if (containerHeight + controlButtonHeight < window.innerHeight) {
        this.controlButton.current.classList.remove('fixed_mod')
        this.setState({
          isBtnAddFixed: false,
        })
      }
    } else {
      if (containerHeight >= window.innerHeight) {
        this.controlButton.current.classList.add('fixed_mod')
        this.setState({
          isBtnAddFixed: true,
        })
      }
    }
  }

  allSongsIds = this.props.allSongs.map(({ songId }) => songId)

  setSelectedSongs = (selectedSongs) =>
    this.setState({ selectedSongs: new Set(selectedSongs) })

  componentDidMount() {
    this.setBtnControlFixed()
  }

  componentDidUpdate() {
    this.setBtnControlFixed()
  }

  startPlaylistHandler = () => {
    this.props.startPlaylist()

    if (history.location.pathname === '/player')
      this.props.closePlaylistHandler(), this.props.closeSettingsHandler()
    else history.push('/player')
  }

  render() {
    // Note: component reused from alarm submenu, so many of the same classes prefixed with 'alarm_...' are reused
    return (
      <div className="popup alarm_mod" onClick={(e) => e.stopPropagation()}>
        <button
          className="close_btn right_pos_mod alarm_mod"
          onClick={this.props.closePlaylistHandler}
        ></button>
        <div className="popup_in" ref={this.container}>
          <div className="popup_content">
            <h2 className="section_title offset_mod alarm_mod">
              {t('playlist.MY_PLAYLIST')}
            </h2>
            <div className="section_subtitle v2_mod">
              {t('playlist.MY_PLAYLIST_DESCR')}
            </div>
          </div>
          <div className="alarm_container sm_mod">
            <div className="btn_add_group">
              <button
                className={`btn_add playlist_mod ${
                  this.state.tab === 'songs' ? 'active' : ''
                }`}
                onClick={() => this.changeTabHandler('songs')}
              >
                {t('playlist.CREATE_MY_PLAYLIST')}
              </button>

              <button
                className={`btn_add playlist_mod ${
                  this.state.tab === 'playlist' ? 'active' : ''
                }`}
                onClick={() => this.changeTabHandler('playlist')}
              >
                {t('playlist.MY_PLAYLIST')}
                {this.props.playlist.length ? (
                  <span>&nbsp;({this.props.playlist.length * 20}min)</span>
                ) : (
                  ''
                )}
              </button>
            </div>
            {this.state.tab === 'songs' && <SettingsPlaylistSongList />}
            {this.state.tab === 'playlist' && (
              <div className="alarm_btn_wrap playlist_mod" ref={this.controlButton}>
                <button
                  className="btn_add playlist_play_btn_mod"
                  disabled={!this.props.playlist.length}
                  onClick={this.startPlaylistHandler}
                >
                  <PlayIcon className="playlist_play_icon" />
                </button>
              </div>
            )}
            {this.state.tab === 'playlist' && (
              <div className="playlist_wrap">
                <SettingsPlaylistSelectedList />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ player: { allSongs, playlist } }) => ({
  allSongs,
  playlist,
})

const willMapDispatchToProps = {
  startPlaylist,
}

export default connect(mapStateToProps, willMapDispatchToProps)(SettingsPlaylist)

SettingsPlaylist.propTypes = {
  allSongs: PropTypes.array.isRequired,
  playlist: PropTypes.array.isRequired,
  startPlaylist: PropTypes.func.isRequired,
  closePlaylistHandler: PropTypes.func.isRequired,
  closeSettingsHandler: PropTypes.func.isRequired,
}
